module.exports = __webpack_public_path__ + "static/media/photo-15.f73358bb.png";